<template>
  <v-app>
    <v-row>
      <newsletter-dialog
        :is-visible.sync="newsletterDialog"
        :categories="newsletterCategories"
        :email="newsletterUser.email"
        :name="newsletterUser.name"
        @submit="openSnackBar"
      >
      </newsletter-dialog>
    </v-row>
    <v-row>
      <snackbar
        v-model="snackbar"
        :snackbar="snackbar"
        :snackbar-data="snackbarData"
        @submit="openSnackBar"
      >
      </snackbar>
    </v-row>
  </v-app>
</template>

<script>
// Components
import NewsletterDialog from "@/components/common-components/NewsletterDialog/NewsletterDialog";
import Snackbar from "@/components/Snackbar";

// Libs
import isEmpty from "lodash/isEmpty";

export default {
  name: "WidgetNewsletter",
  components: {
    NewsletterDialog,
    Snackbar
  },
  data() {
    return {
      initialDataWidgets: window.initialDataWidgets,
      newsletterCategories: [],
      newsletterUser: {
        email: "",
        name: ""
      },
      newsletterDialog: false,
      snackbar: false,
      snackbarData: undefined
    };
  },
  methods: {
    openSnackBar(data) {
      this.snackbar = true;
      this.snackbarData = data;
    }
  },
  created() {
    if (!isEmpty(this.initialDataWidgets)) {
      const {
        newsletter_categories,
        user_email,
        user_name
      } = this.initialDataWidgets.newsletterinitial;
      this.newsletterCategories = newsletter_categories || [];
      this.newsletterUser.email = user_email || "";
      this.newsletterUser.name = user_name || "";
      this.$store.dispatch("setMess", this.initialDataWidgets.mess);
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/common-widgets";
</style>
